<div *ngFor="let field of fields; let i = index">
  <div
    *ngIf="
      field &&
      field.dpReforma &&
      (i === 0 || field.dpReforma !== fields[i - 1].dpReforma)
    "
    class="mt-2 mb-2"
  >
    <strong> RE {{ field.dpReforma }} </strong>
  </div>
  <div class="wrapper" [ngClass]="{ stylesToPF: stateToPFAndWatchBoth }">
    <ng-container *ngIf="field.cdTipo && field.cdTipo == 'FILE'">
      <div class="firstPart">
        <label>{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label
          *ngIf="field.dpFichero && operation == 'detail'"
          (click)="downloadFile(field)"
          class="downloadPointer"
        >
          <em class="fas fa-file-download mr-2"></em>
          <span>{{ field.dpFichero }}</span>
        </label>

        <div class="dummyButtonContainerAux" *ngIf="operation == 'edit'">
          <div class="dummyButton">
            <em class="fas fa-file-upload"></em>
          </div>
          <div class="dummyFileInputAux" style="min-height: 20px !important">
            <div
              class="dummyFileNameAux adjustText"
              style="max-height: 20px !important"
            >
              {{ field.dpFichero }}
            </div>
          </div>
        </div>
        <input
          *ngIf="operation == 'edit'"
          class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
          type="file"
          (change)="handleFileInput($event, i)"
        />
        <div
          class="alingMandatoryAux"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
        >
          *
        </div>
      </div>
    </ng-container>
    <ng-container
      *ngIf="field.cdTipo && field.cdTipo != 'DBLIST' && field.cdTipo != 'FILE'"
    >
      <div class="firstPart">
        <label>{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label *ngIf="operation == 'detail'">{{ field.dpValor }}</label>
        <input *ngIf="operation == 'edit'" [(ngModel)]="field.dpValor" />
      </div>
    </ng-container>
    <ng-container *ngIf="field.cdTipo && field.cdTipo == 'DBLIST'">
      <div class="firstPart">
        <label *ngIf="field.dpCampo">{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label *ngIf="operation == 'detail' && !field.dpValor">{{
          field.dpValor
        }}</label>

        <app-input-selector-with-search
          *ngIf="operation == 'edit'"
          [list]="dbLists[i]"
          [fields]="['valor']"
          [id]="'valor'"
          [item]="field.dpValor"
          (sendValue)="valueSelector($event, i)"
        ></app-input-selector-with-search>
      </div>
    </ng-container>
    <ng-container *ngIf="field.tipo && field.tipo == 'FILE'">
      <div class="firstPart">
        <label>{{ field.campo }}</label>
      </div>
      <div class="secondPart">
        <label
          *ngIf="field.nombreFichero && operation == 'detail'"
          (click)="downloadFile(field)"
          class="downloadPointer"
        >
          <em class="fas fa-file-download mr-2"></em>
          <span>{{ field.nombreFichero }}</span>
        </label>

        <div class="dummyButtonContainerAux" *ngIf="operation == 'edit'">
          <div class="dummyButton">
            <em class="fas fa-file-upload"></em>
          </div>
          <div class="dummyFileInputAux" style="min-height: 20px !important">
            <div
              class="dummyFileNameAux adjustText"
              style="max-height: 20px !important"
            >
              {{ field.dpFichero }}
            </div>
          </div>
        </div>
        <input
          *ngIf="operation == 'edit'"
          class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
          type="file"
          (change)="handleFileInput($event, i)"
        />
        <div
          class="alingMandatory"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
        >
          *
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="field.tipo && field.tipo == 'TITLE'">
      <div class="groupTitle2">
        <label>{{ field.valor }}</label>
      </div>
      <div class="secondPart">
        <label></label>
      </div>
    </ng-container>
    <ng-container
      *ngIf="field.tipo && field.tipo != 'FILE' && field.tipo != 'TITLE'"
    >
      <div class="firstPart">
        <label>{{ field.campo }}</label>
      </div>
      <div class="secondPart">
        <label *ngIf="operation == 'detail'">{{ field.valor }}</label>

        <input *ngIf="operation == 'edit'" [(ngModel)]="field.valor" />
        <span
          class="alingMandatory"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
          >*</span
        >
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        field.camposdisponibles &&
        field.camposdisponibles.cdTipo &&
        field.camposdisponibles.cdTipo == 'TITLE'
      "
    >
      <div class="groupTitle">
        <label>{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label></label>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        field.camposdisponibles &&
        field.camposdisponibles.cdTipo &&
        field.camposdisponibles.cdTipo == 'FILE' &&
        checkifHasToHide(field)
      "
    >
      <div class="firstPart">
        <label>{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label
          *ngIf="field.dpFichero && operation == 'detail'"
          (click)="downloadFile(field)"
          class="downloadPointer"
        >
          <em class="fas fa-file-download mr-2"></em>
          <span>{{ convertFileName(field.dpFichero) }}</span>
        </label>

        <div class="dummyButtonContainerAux" *ngIf="operation == 'edit'">
          <div class="dummyButton">
            <em class="fas fa-file-upload"></em>
          </div>
          <div class="dummyFileInputAux" style="min-height: 20px !important">
            <div
              class="dummyFileNameAux adjustText"
              style="max-height: 20px !important"
            >
              {{ field.dpFichero }}
            </div>
          </div>
        </div>
        <input
          *ngIf="operation == 'edit'"
          class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
          type="file"
          (change)="handleFileInput($event, i)"
        />
        <div
          class="alingMandatoryAux"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
        >
          *
        </div>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        field.camposdisponibles &&
        field.camposdisponibles.cdTipo &&
        (field.camposdisponibles.cdTipo == 'STRING' ||
          field.camposdisponibles.cdTipo === 'INT' ||
          field.camposdisponibles.cdTipo === 'ACC' ||
          field.camposdisponibles.cdTipo == 'TEXTAREA') &&
        checkifHasToHide(field)
      "
    >
      <div class="firstPart">
        <label>{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label *ngIf="operation == 'detail'">{{ field.dpValor }}</label>

        <input
          *ngIf="
            operation == 'edit' && field.camposdisponibles.cdTipo === 'INT'
          "
          type="number"
          min="0"
          [(ngModel)]="field.dpValor"
          (blur)="fillSimilarField('text', field)"
          (change)="setNumber(field)"
        />
        <input
          *ngIf="
            operation == 'edit' &&
            (field.camposdisponibles.cdTipo === 'STRING' ||
              field.camposdisponibles.cdTipo == 'ACC')
          "
          [(ngModel)]="field.dpValor"
          (blur)="fillSimilarField('text', field)"
        />
        <textarea
          *ngIf="
            operation == 'edit' && field.camposdisponibles.cdTipo == 'TEXTAREA'
          "
          [(ngModel)]="field.dpValor"
          (blur)="fillSimilarField('text', field)"
          type="textarea"
          style="width: 266px; min-height: 75px"
        ></textarea>
        <span
          class="alingMandatory"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
          >*</span
        >
        <button
          *ngIf="field.camposdisponibles.cdTipo == 'ACC' && operation == 'edit'"
          class="searchButton"
          type="button"
          (click)="getInfoOfACCFields(field)"
        >
          <div class="iconSearch">
            <em class="fa-search fas"></em>
          </div>
        </button>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        field.camposdisponibles &&
        field.camposdisponibles.cdTipo &&
        field.camposdisponibles.cdTipo == 'DATE' &&
        checkifHasToHide(field)
      "
    >
      <div class="firstPart">
        <label>{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label *ngIf="operation == 'detail'">{{
          field.dpValor | date : "dd/MM/yyyy"
        }}</label>

        <input
          *ngIf="operation == 'edit'"
          type="date"
          [(ngModel)]="field.dpValor"
        />
        <span
          class="alingMandatory"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
          >*</span
        >
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        field.camposdisponibles &&
        field.camposdisponibles.cdTipo &&
        field.camposdisponibles.cdTipo === 'LITERAL' &&
        checkifHasToHide(field)
      "
    >
      <div class="firstPartLiteral">
        <label>{{ field.dpValor }}</label>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        field.camposdisponibles &&
        field.camposdisponibles.cdTipo &&
        field.camposdisponibles.cdTipo == 'BOOL'
      "
    >
      <div class="firstPart">
        <label>{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label
          *ngIf="operation == 'detail' && field.dpValor === 'si'; else elseBool"
          >{{ "Sí" }}</label
        >
        <ng-template #elseBool>
          <label *ngIf="operation == 'detail'">{{
            field.dpValor | titlecase
          }}</label>
        </ng-template>

        <span *ngIf="operation == 'edit'">
          Sí
          <input
            type="radio"
            value="si"
            [checked]="field.dpValor == 'si'"
            (change)="changeValue($event, field)"
          />
          No
          <input
            type="radio"
            value="no"
            [checked]="field.dpValor == 'no'"
            (change)="changeValue($event, field)"
          />
        </span>
        <span
          class="alingMandatory"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
          >*</span
        >
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        field.camposdisponibles &&
        field.camposdisponibles.cdTipo &&
        field.camposdisponibles.cdTipo == 'DBLIST' &&
        checkifHasToHide(field)
      "
    >
      <div class="firstPart">
        <label *ngIf="field.dpCampo">{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label *ngIf="operation == 'detail' && field.dpValor != null">{{
          field.dpValor
        }}</label>
        <div class="selectorWithSearch" *ngIf="operation == 'edit'">
          <app-input-selector-with-search
            [list]="dbLists[i]"
            [fields]="['valor', 'desc']"
            [id]="'valor'"
            [item]="field.dpValor"
            (sendValue)="valueSelector($event, i)"
          ></app-input-selector-with-search>
        </div>

        <span
          class="alingMandatory"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
          >*</span
        >
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        field.camposdisponibles &&
        field.camposdisponibles.cdTipo &&
        field.camposdisponibles.cdTipo == 'LIST' &&
        checkifHasToHide(field)
      "
    >
      <div class="firstPart">
        <label *ngIf="field.dpCampo">{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label *ngIf="operation == 'detail' && !field.dpValor.valor">{{
          field.dpValor
        }}</label>
        <div class="selectorWithSearch" *ngIf="operation == 'edit'">
          <app-input-selector-with-search
            [list]="dbLists[i]"
            [fields]="['valor']"
            [id]="'valor'"
            [item]="field.dpValor"
            (sendValue)="valueSelector($event, i)"
          ></app-input-selector-with-search>
        </div>

        <span
          class="alingMandatory"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
          >*</span
        >
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        field.camposdisponibles &&
        field.camposdisponibles.cdTipo &&
        field.camposdisponibles.cdTipo == 'STATICLIST' &&
        checkifHasToHide(field)
      "
    >
      <div class="firstPart">
        <label *ngIf="field.dpCampo">{{ field.dpCampo }}</label>
      </div>
      <div class="secondPart">
        <label *ngIf="operation == 'detail' && field.dpValor != null">{{
          getValueLabelStaticList(dbLists[i], field.dpValor)
        }}</label>
        <div class="selectorWithSearch" *ngIf="operation == 'edit'">
          <app-input-selector-with-search
            [list]="dbLists[i]"
            [fields]="['label']"
            [id]="'valor'"
            [item]="getValueStaticList(dbLists[i], field.dpValor)"
            (sendValue)="valueSelector($event, i)"
          ></app-input-selector-with-search>
        </div>

        <span
          class="alingMandatory"
          *ngIf="
            operation == 'edit' &&
            field.camposdisponibles.ccObligatorio &&
            field.camposdisponibles.ccObligatorio == 1
          "
          >*</span
        >
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        (!field.camposdisponibles || !field.camposdisponibles.cdTipo) &&
        !field.tipo &&
        !field.cdTipo
      "
    >
      <div class="firstPartLiteral" *ngIf="field.dpCampo == field.dpValor">
        <label>{{ field.dpValor }}</label>
      </div>
      <div class="firstPart" *ngIf="field.dpCampo != field.dpValor">
        <label>{{ field.dpCampo }}</label>
      </div>
      <div
        class="secondPart"
        *ngIf="operation == 'detail' && field.dpCampo != field.dpValor"
      >
        <label *ngIf="field.dpFichero">{{ field.dpFichero }}</label>
        <label *ngIf="!field.dpFichero">{{ field.dpValor }}</label>
      </div>
      <div class="secondPart" *ngIf="operation == 'edit'">
        <input *ngIf="field.dpFichero" [(ngModel)]="field.dpFichero" />
        <input *ngIf="!field.dpFichero" [(ngModel)]="field.dpValor" />
      </div>
    </ng-container>
  </div>
</div>
